import * as yup from 'yup';

// Keys whose value must validate as a non-negative number. The `value` column
// itself is a generic string on the backend, so this list is what makes a
// specific setting numeric on the frontend without constraining future keys.
export const numericSettingKeys = ['job_ad_fee'];

export const numericSettingValueValidationSchema = yup.object().shape({
  value: yup
    .number()
    .typeError('Value must be a number')
    .min(0, 'Value must be zero or greater')
    .required('Value is required'),
});

export const settingValueValidationSchema = yup.object().shape({
  value: yup.string().required('Value is required'),
});

// Per-company overrides allow an empty value to clear the override and
// revert the company back to the global default, so these variants drop
// the `required` rule that the global settings schemas above enforce.
export const numericSettingValueOptionalValidationSchema = yup.object().shape({
  value: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Value must be a number')
    .min(0, 'Value must be zero or greater')
    .notRequired(),
});

export const settingValueOptionalValidationSchema = yup.object().shape({
  value: yup.string().notRequired(),
});
